var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "manual"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit(_vm.restrictionConfig.pickupExists ? _vm.restrictionConfig.pickupExists : null)
      }
    }
  }, [((_vm.restrictionConfig && _vm.restrictionConfig.isFmBaggingLoc)) ? _c('div', [_c('div', {
    staticClass: "form-group1 row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select Scan Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group1 row"
  }, [_c('div', {
    staticClass: "col-md-3 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handovertype),
      expression: "handovertype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "handovertypebag",
      "id": "handovertypebag",
      "value": "bag"
    },
    domProps: {
      "checked": _vm._q(_vm.handovertype, "bag")
    },
    on: {
      "change": [function($event) {
        _vm.handovertype = "bag"
      }, _vm.clearhandoverError]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "handovertypebag"
    }
  }, [_vm._v("Bags")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handovertype),
      expression: "handovertype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "handovertypeshipment",
      "id": "handovertypeshipment",
      "value": "shipment"
    },
    domProps: {
      "checked": _vm._q(_vm.handovertype, "shipment")
    },
    on: {
      "change": [function($event) {
        _vm.handovertype = "shipment"
      }, _vm.clearhandoverError]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "handovertypeshipment"
    }
  }, [_vm._v("Shipments")])])], 1), _vm._v(" "), (_vm.handovererrors) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.handovererrors))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "color": "#d70a0a",
      "cursor": "pointer"
    }
  }, [_c('span', {
    on: {
      "click": _vm.resethandovertype
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "font-size": "15px"
    }
  }), _vm._v("  Reset")])])]), _vm._v(" "), (_vm.handovertype == 'bag') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handoverBag),
      expression: "handoverBag"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('handoverBag')
    },
    attrs: {
      "type": "text",
      "placeholder": "Bag Number",
      "name": "handoverBag",
      "id": "handoverBag"
    },
    domProps: {
      "value": (_vm.handoverBag)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fmBagSealInScan()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.handoverBag = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.handoverBagError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.handoverBagError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    staticStyle: {
      "margin-top": "29px"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.fmBagSealInScan()
      }
    }
  }, [_vm._v("Inscan")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Total")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#0645AD",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.openFMShipmentPendencyList()
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.fmbagInScanObj.shipmentCount || 0))])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.handovertype == 'bag') ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', [_c('label', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Excess Count :")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.fmbagInScanObj.excessCount || 0))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "common-success",
    staticStyle: {
      "white-space": "nowrap",
      "width": "auto"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.handoverBag || !_vm.isfmbagInScan
    },
    on: {
      "click": function($event) {
        return _vm.completeHubInScan()
      }
    }
  }, [_vm._v("Complete Hub Inscan")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), ((!_vm.restrictionConfig.pickupExists)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Weight Type")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.WeightType),
      expression: "WeightType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('WeightType')
    },
    attrs: {
      "name": "WeightType",
      "id": "WeightType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.WeightType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getDimensions]
    }
  }, [_c('option', {
    attrs: {
      "value": "NVW"
    }
  }, [_vm._v("No Volumetric Weight")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CB"
    }
  }, [_vm._v("Custom-Boxes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CP"
    }
  }, [_vm._v("Custom-PolyBags")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PB"
    }
  }, [_vm._v("PolyBags")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('WeightType')),
      expression: "errors.has('WeightType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('WeightType')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Length")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-arrows-alt'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShipmentLength),
      expression: "ShipmentLength"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('decimal|min_value:0.1|required|max_value:250'),
      expression: "'decimal|min_value:0.1|required|max_value:250'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('ShipmentLength')
    },
    attrs: {
      "type": "text",
      "disabled": _vm.isDisabled,
      "placeholder": "Length",
      "name": "ShipmentLength",
      "id": "ShipmentLength"
    },
    domProps: {
      "value": (_vm.ShipmentLength)
    },
    on: {
      "keyup": _vm.showCondition,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShipmentLength = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ShipmentLength')),
      expression: "errors.has('ShipmentLength')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ShipmentLength')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Breadth")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-arrows-alt'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShipmentBreadth),
      expression: "ShipmentBreadth"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('decimal|min_value:0.1|required|max_value:250'),
      expression: "'decimal|min_value:0.1|required|max_value:250'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('ShipmentBreadth')
    },
    attrs: {
      "type": "text",
      "disabled": _vm.isDisabled,
      "placeholder": "Breadth",
      "name": "ShipmentBreadth",
      "id": "ShipmentBreadth"
    },
    domProps: {
      "value": (_vm.ShipmentBreadth)
    },
    on: {
      "keyup": _vm.showCondition,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShipmentBreadth = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ShipmentBreadth')),
      expression: "errors.has('ShipmentBreadth')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ShipmentBreadth')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Height")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-arrows-alt'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShipmentHeight),
      expression: "ShipmentHeight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('decimal|min_value:0.1|required|max_value:250'),
      expression: "'decimal|min_value:0.1|required|max_value:250'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('ShipmentHeight')
    },
    attrs: {
      "type": "text",
      "disabled": _vm.isDisabled,
      "placeholder": "Height",
      "name": "ShipmentHeight",
      "id": "ShipmentHeight"
    },
    domProps: {
      "value": (_vm.ShipmentHeight)
    },
    on: {
      "keyup": _vm.showCondition,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShipmentHeight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ShipmentHeight')),
      expression: "errors.has('ShipmentHeight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ShipmentHeight')))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWeight),
      expression: "showWeight"
    }],
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Weight")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-arrows-alt'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShipmentWeight),
      expression: "ShipmentWeight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('decimal|min_value:0.01|required|max_value:1000'),
      expression: "'decimal|min_value:0.01|required|max_value:1000'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('ShipmentWeight')
    },
    attrs: {
      "type": "text",
      "disabled": _vm.isDisabled,
      "placeholder": "Weight",
      "name": "ShipmentWeight",
      "id": "ShipmentWeight"
    },
    domProps: {
      "value": (_vm.ShipmentWeight)
    },
    on: {
      "keyup": _vm.checkIsShipmentWeight,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShipmentWeight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ShipmentWeight')),
      expression: "errors.has('ShipmentWeight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ShipmentWeight')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipment ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShipmentID),
      expression: "ShipmentID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "ShipmentID",
    class: {
      'form-control': true, 'error': _vm.errors.has('ShipmentID')
    },
    attrs: {
      "type": "text",
      "placeholder": "Shipment ID",
      "name": "ShipmentID",
      "id": "ShipmentID",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.ShipmentID)
    },
    on: {
      "keyup": function($event) {
        return _vm.checkShipmentInput($event)
      },
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShipmentID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ShipmentID')),
      expression: "errors.has('ShipmentID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ShipmentID')))])], 1), _vm._v(" "), (_vm.showIconInput) ? _c('b-form-fieldset', [_c('b-input-group', _vm._b({}, 'b-input-group', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false), [_vm._v(_vm._s(_vm.displayShipmentid))])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIsConfirmPhyWt),
      expression: "showIsConfirmPhyWt"
    }],
    staticClass: "col-md-6 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isConfirmPhyWt),
      expression: "isConfirmPhyWt"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isConfirmPhyWt",
      "name": "isConfirmPhyWt"
    },
    domProps: {
      "checked": Array.isArray(_vm.isConfirmPhyWt) ? _vm._i(_vm.isConfirmPhyWt, null) > -1 : (_vm.isConfirmPhyWt)
    },
    on: {
      "click": _vm.uncheck,
      "change": function($event) {
        var $$a = _vm.isConfirmPhyWt,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isConfirmPhyWt = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isConfirmPhyWt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isConfirmPhyWt = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "isConfirmPhyWt"
    }
  }, [_vm._v("Confirm Physical Weight")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.showisConfirmPhyWtErr))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIsConfirmVolWt),
      expression: "showIsConfirmVolWt"
    }],
    staticClass: "col-md-6 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isConfirmVolWt),
      expression: "isConfirmVolWt"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isConfirmVolWt",
      "name": "isConfirmVolWt"
    },
    domProps: {
      "checked": Array.isArray(_vm.isConfirmVolWt) ? _vm._i(_vm.isConfirmVolWt, null) > -1 : (_vm.isConfirmVolWt)
    },
    on: {
      "click": _vm.uncheck,
      "change": function($event) {
        var $$a = _vm.isConfirmVolWt,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isConfirmVolWt = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isConfirmVolWt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isConfirmVolWt = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "isConfirmVolWt"
    }
  }, [_vm._v("Confirm Volumetric Weight")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.showConfirmVolWtErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.IsResultCodeBtn) ? _c('button', {
    staticClass: "common-success",
    style: ((_vm.restrictionConfig && _vm.restrictionConfig.isFmBaggingLoc && !_vm.isfmbagInScan && _vm.handovertype == 'bag') ? 'cursor: not-allowed;opacity: 0.6; pointer-events: auto;' : ''),
    attrs: {
      "type": "submit",
      "disabled": _vm.restrictionConfig && _vm.restrictionConfig.isFmBaggingLoc && !_vm.isfmbagInScan && _vm.handovertype == 'bag'
    }
  }, [_vm._v("Inscan")]) : _vm._e(), _vm._v(" "), (_vm.IsResultCodeBtn) ? _c('button', {
    staticClass: "common-success",
    style: ((_vm.restrictionConfig && _vm.restrictionConfig.isFmBaggingLoc && !_vm.isfmbagInScan && _vm.handovertype == 'bag') ? 'cursor: not-allowed;opacity: 0.6; pointer-events: auto;' : ''),
    attrs: {
      "type": "button",
      "disabled": _vm.restrictionConfig && _vm.restrictionConfig.isFmBaggingLoc && !_vm.isfmbagInScan && _vm.handovertype == 'bag'
    },
    on: {
      "click": _vm.manualInscan
    }
  }, [_vm._v("Inscan")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), ((_vm.restrictionConfig && _vm.restrictionConfig.pickupExists)) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-md-9"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Weight Type")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.WeightType),
      expression: "WeightType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('WeightType')
    },
    attrs: {
      "name": "WeightType",
      "id": "WeightType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.WeightType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getDimensions]
    }
  }, [_c('option', {
    attrs: {
      "value": "NVW"
    }
  }, [_vm._v("No Volumetric Weight")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('WeightType')),
      expression: "errors.has('WeightType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('WeightType')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1%"
    }
  }, [_c('div', {
    staticClass: "col-sm-4 col-md-9"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipment ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShipmentID),
      expression: "ShipmentID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "ShipmentID",
    class: {
      'form-control': true, 'error': _vm.errors.has('ShipmentID')
    },
    attrs: {
      "type": "text",
      "placeholder": "Shipment ID",
      "name": "ShipmentID",
      "id": "ShipmentID",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.ShipmentID)
    },
    on: {
      "keyup": function($event) {
        return _vm.checkShipmentInput($event)
      },
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShipmentID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ShipmentID')),
      expression: "errors.has('ShipmentID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ShipmentID')))])], 1), _vm._v(" "), (_vm.showIconInput) ? _c('b-form-fieldset', [_c('b-input-group', _vm._b({}, 'b-input-group', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false), [_vm._v(_vm._s(_vm.displayShipmentid))])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1%"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIsConfirmPhyWt),
      expression: "showIsConfirmPhyWt"
    }],
    staticClass: "col-md-5 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isConfirmPhyWt),
      expression: "isConfirmPhyWt"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isConfirmPhyWt",
      "name": "isConfirmPhyWt"
    },
    domProps: {
      "checked": Array.isArray(_vm.isConfirmPhyWt) ? _vm._i(_vm.isConfirmPhyWt, null) > -1 : (_vm.isConfirmPhyWt)
    },
    on: {
      "click": _vm.uncheck,
      "change": function($event) {
        var $$a = _vm.isConfirmPhyWt,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isConfirmPhyWt = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isConfirmPhyWt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isConfirmPhyWt = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "isConfirmPhyWt"
    }
  }, [_vm._v("Confirm Physical Weight")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.showisConfirmPhyWtErr))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIsConfirmVolWt),
      expression: "showIsConfirmVolWt"
    }],
    staticClass: "col-md-5 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isConfirmVolWt),
      expression: "isConfirmVolWt"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isConfirmVolWt",
      "name": "isConfirmVolWt"
    },
    domProps: {
      "checked": Array.isArray(_vm.isConfirmVolWt) ? _vm._i(_vm.isConfirmVolWt, null) > -1 : (_vm.isConfirmVolWt)
    },
    on: {
      "click": _vm.uncheck,
      "change": function($event) {
        var $$a = _vm.isConfirmVolWt,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isConfirmVolWt = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isConfirmVolWt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isConfirmVolWt = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "isConfirmVolWt"
    }
  }, [_vm._v("Confirm Volumetric Weight")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.showConfirmVolWtErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-md-9"
  }, [(!_vm.IsResultCodeBtn) ? _c('button', {
    staticClass: "common-success",
    style: ((_vm.restrictionConfig && _vm.restrictionConfig.isFmBaggingLoc && !_vm.isfmbagInScan && _vm.handovertype == 'bag') ? 'cursor: not-allowed;opacity: 0.6; pointer-events: auto;' : ''),
    attrs: {
      "type": "submit",
      "disabled": _vm.restrictionConfig && _vm.restrictionConfig.isFmBaggingLoc && !_vm.isfmbagInScan && _vm.handovertype == 'bag'
    }
  }, [_vm._v("Inscan")]) : _vm._e(), _vm._v(" "), (_vm.IsResultCodeBtn) ? _c('button', {
    staticClass: "common-success",
    style: ((_vm.restrictionConfig && _vm.restrictionConfig.isFmBaggingLoc && !_vm.isfmbagInScan && _vm.handovertype == 'bag') ? 'cursor: not-allowed;opacity: 0.6; pointer-events: auto;' : ''),
    attrs: {
      "type": "button",
      "disabled": _vm.restrictionConfig && _vm.restrictionConfig.isFmBaggingLoc && !_vm.isfmbagInScan && _vm.handovertype == 'bag'
    },
    on: {
      "click": _vm.manualInscan
    }
  }, [_vm._v("Inscan")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div', {
    style: (_vm.pickUpBasketData.length > 5 ? 'overflow: auto; height: 295px;overflow-x: hidden;' : '')
  }, _vm._l((_vm.pickUpBasketData), function(data, i) {
    return _c('div', {
      staticClass: "row",
      staticStyle: {
        "margin-top": "2%"
      }
    }, [_c('div', {
      staticClass: "col-sm-4 col-md-9"
    }, [_c('span', {
      class: {
        'common-w1-btn': i == 0, 'common-w3-btn': i % 2 === 0 && i !== 0, 'common-w2-btn': i % 2 !== 0
      }
    }, [_c('b', [_vm._v(_vm._s(data.nextbagdestination) + "    \n                          "), _c('img', {
      staticStyle: {
        "width": "30px",
        "height": "28px",
        "vertical-align": "middle"
      },
      attrs: {
        "src": "static/img/box.png",
        "alt": "Box icon"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right-section"
    }, [_c('b', {
      staticStyle: {
        "font-size": "20px"
      }
    }, [_vm._v(_vm._s(data.count))]), _vm._v(" "), _c('button', {
      class: {
        'common-w1-btn-btn': i == 0, 'common-w3-btn-btn': i % 2 === 0 && i !== 0, 'common-w2-btn-btn': i % 2 !== 0
      },
      staticStyle: {
        "margin-left": "20px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.fetchBagShipmentList(data, 'bag', i), _vm.shipmentModal = true
        }
      }
    }, [_c('b', [_c('i', {
      staticClass: "fa fa-cube"
    }), _vm._v(" Create Bag")])]), _vm._v(" "), _c('button', {
      class: {
        'common-w1-btn-btn': i == 0, 'common-w3-btn-btn': i % 2 === 0 && i !== 0, 'common-w2-btn-btn': i % 2 !== 0
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.fetchBagShipmentList(data, 'delink', i), _vm.shipmentModal = true
        }
      }
    }, [_c('b', [_c('i', {
      staticClass: "fa fa-unlink"
    }), _vm._v(" Delink AWB")])])])])])])
  }), 0)]) : _vm._e()])]), _vm._v(" "), ((_vm.restrictionConfig && _vm.restrictionConfig.pickupExists)) ? _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fullSuccessMessage),
      expression: "fullSuccessMessage"
    }],
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', {
    staticStyle: {
      "text-align": "left !IMPORTANT",
      "font-size": "32px"
    }
  }, [(_vm.displayMandatoryWeighingField(_vm.Destination)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Next Bag Destination :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.Destination))])])]) : _vm._e(), _vm._v(" "), (_vm.displayMandatoryWeighingField(_vm.displayShipmentid)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Scanned Shipment ID : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.displayShipmentid))])])]) : _vm._e(), _vm._v(" "), (_vm.displayMandatoryWeighingField(_vm.ZoneName)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Zone :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.ZoneName))])])]) : _vm._e(), _vm._v(" "), (_vm.displayMandatoryWeighingField(_vm.ServiceType)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Service Type : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.ServiceType))])]), _vm._v(" "), (_vm.priorityflag && _vm.displayMandatoryWeighingField(_vm.priorityflag)) ? _c('b', [_c('span', {
    staticStyle: {
      "color": "red",
      "margin-left": "45%"
    }
  }, [_vm._v(" " + _vm._s(_vm.priorityflag))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayMandatoryWeighingField(_vm.MOT)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("MOT : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.MOT))])])]) : _vm._e(), _vm._v(" "), (_vm.displayMandatoryWeighingField(_vm.ShipmentType)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Shipment Type : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.ShipmentType))])])]) : _vm._e()])])])])]) : _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fullSuccessMessage),
      expression: "fullSuccessMessage"
    }],
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', {
    staticStyle: {
      "text-align": "left !IMPORTANT",
      "font-size": "32px"
    }
  }, [(_vm.mpsType && _vm.displayMandatoryWeighingField(_vm.mpsType)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(" " + _vm._s(_vm.mpsType))])])]) : _vm._e(), _vm._v(" "), (_vm.displayMandatoryWeighingField(_vm.ServiceType)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Service Type : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.ServiceType))])]), _vm._v(" "), (_vm.priorityflag && _vm.displayMandatoryWeighingField(_vm.priorityflag)) ? _c('b', [_c('span', {
    staticStyle: {
      "color": "red",
      "margin-left": "45%"
    }
  }, [_vm._v(" " + _vm._s(_vm.priorityflag))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayMandatoryWeighingField(_vm.MOT)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("MOT : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.MOT))])])]) : _vm._e(), _vm._v(" "), (_vm.displayMandatoryWeighingField(_vm.ShipmentType)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Shipment Type : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.ShipmentType))])])]) : _vm._e(), _vm._v(" "), (_vm.displayMandatoryWeighingField(_vm.displayShipmentid)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Shipping ID : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.displayShipmentid))])])]) : _vm._e(), _vm._v(" "), (_vm.displayMandatoryWeighingField(_vm.Destination)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Destination :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.Destination))])])]) : _vm._e(), _vm._v(" "), (_vm.ServiceType === 'INTRASDD' && _vm.displayMandatoryWeighingField(_vm.ParentHubs)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Parent Hubs :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.ParentHubs))])])]) : _vm._e(), _vm._v(" "), (_vm.displayMandatoryWeighingField(_vm.ProcessCode)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Process Code :"), _c('span', {
    staticStyle: {
      "color": "#4306b9"
    }
  }, [_vm._v(" " + _vm._s(_vm.ProcessCode))])])]) : _vm._e(), _vm._v(" "), (_vm.displayMandatoryWeighingField(_vm.ZoneName)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Zone Name :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.ZoneName))])])]) : _vm._e(), _vm._v(" "), (_vm.displayMandatoryWeighingField(_vm.VolumetricWeightPrint)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Volumetric Weight :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.VolumetricWeightPrint))])])]) : _vm._e(), _vm._v(" "), (_vm.displayMandatoryWeighingField(_vm.PhysicalWeightPrint)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Physical Weight :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.PhysicalWeightPrint))])])]) : _vm._e(), _vm._v(" "), (_vm.clientType === 'International' && _vm.displayMandatoryWeighingField(_vm.clientType)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Client Type :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.clientType))])])]) : _vm._e(), _vm._v(" "), (_vm.showQuentity && _vm.displayMandatoryWeighingField(_vm.MpsGroupID)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("MPS GroupID :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.MpsGroupID))])])]) : _vm._e(), _vm._v(" "), (_vm.showQuentity && _vm.displayMandatoryWeighingField(_vm.MPSQuantity)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("MPS Quantity :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.MPSQuantity))])])]) : _vm._e(), _vm._v(" "), (_vm.section && _vm.displayMandatoryWeighingField(_vm.section)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Section :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.section))])])]) : _vm._e(), _vm._v(" "), (_vm.bayNo && _vm.displayMandatoryWeighingField(_vm.bayNo)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Bay No :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.bayNo))])])]) : _vm._e(), _vm._v(" "), (_vm.ptlid && _vm.displayMandatoryWeighingField(_vm.ptlid)) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("PTL ID :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.ptlid))])])]) : _vm._e()])])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.invalidTokenModal),
      callback: function($$v) {
        _vm.invalidTokenModal = $$v
      },
      expression: "invalidTokenModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.invalidtokenmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "medium",
      "title": "Confirmation",
      "id": "#confirmationmodal"
    },
    model: {
      value: (_vm.shipmentModal),
      callback: function($$v) {
        _vm.shipmentModal = $$v
      },
      expression: "shipmentModal"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.basketLoader
    },
    on: {
      "update:active": function($event) {
        _vm.basketLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewList),
      expression: "viewList"
    }],
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm",
    staticStyle: {
      "text-align": "center"
    },
    style: ((_vm.basketData.i == 0) ? 'background-color:orange;' : (_vm.basketData.i % 2 === 0 && _vm.basketData.i !== 0) ? 'background-color:#c7a579;' : (_vm.basketData.i % 2 !== 0) ? 'background-color:orangered;' : '')
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("Scanned Shipment List: ")]), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-size": "130%"
    }
  }, [_vm._v(_vm._s(_vm.basketData.nextbagdestination))])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeCreateDelinkModal(), _vm.fetchBagShipmentList(_vm.basketData, _vm.preModal, _vm.basketData.i)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    style: (_vm.ShipmentList.length > 15 ? 'overflow: auto; height: 495px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr.No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment ID")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ShipmentList), function(data, i) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data))])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.createBag),
      expression: "createBag"
    }],
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm",
    staticStyle: {
      "text-align": "center"
    },
    style: ((_vm.basketData.i == 0) ? 'background-color:orange;' : (_vm.basketData.i % 2 === 0 && _vm.basketData.i !== 0) ? 'background-color:#c7a579;' : (_vm.basketData.i % 2 !== 0) ? 'background-color:orangered;' : '')
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("Create Bag: ")]), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-size": "130%"
    }
  }, [_vm._v(_vm._s(_vm.basketData.nextbagdestination))])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeCreateDelinkModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Scan Seal Number:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagSeal),
      expression: "bagSeal"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Seal Number",
      "name": "bagSeal",
      "id": "bagSeal",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.bagSeal)
    },
    on: {
      "keydown": function($event) {
        return _vm.restrictManualTyping($event)
      },
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.scanBagSeal.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagSeal = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.bagSealError))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Scan Shipment ID:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagShipmentID),
      expression: "bagShipmentID"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter A Shipping ID",
      "name": "bagShipmentID",
      "id": "bagShipmentID",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.bagShipmentID)
    },
    on: {
      "keydown": function($event) {
        return _vm.restrictManualTyping($event)
      },
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.scanBagShipment.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagShipmentID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.bagShipmentIDError))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "8%"
    }
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('span', [_c('b', [_vm._v("Shipments for Bag: ")]), _c('b', {
    staticStyle: {
      "cursor": "pointer",
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.basketData.count))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.fetchBagShipmentList(_vm.basketData, 'list', _vm.basketData.i), _vm.preModal = 'bag'
      }
    }
  }, [_c('b', {
    staticStyle: {
      "cursor": "pointer",
      "color": "blue",
      "margin-left": "35%",
      "text-decoration-line": "underline"
    }
  }, [_vm._v("View List")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "8%"
    }
  }, [_c('div', {
    staticClass: "col-sm-4 col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "width": "100%",
      "color": "black",
      "background": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": [function($event) {
        return _vm.closeCreateDelinkModal()
      }, function($event) {
        _vm.shipmentModal = true, _vm.confirmDelink = true, _vm.preModal = 'bag'
      }]
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "width": "100%",
      "color": "white"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.bShipInScan || !_vm.bSealInScan
    },
    on: {
      "click": _vm.closeBag
    }
  }, [_vm._v("Close Bag")])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.delinkShipment),
      expression: "delinkShipment"
    }],
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm",
    staticStyle: {
      "text-align": "center"
    },
    style: ((_vm.basketData.i == 0) ? 'background-color:orange;' : (_vm.basketData.i % 2 === 0 && _vm.basketData.i !== 0) ? 'background-color:#c7a579;' : (_vm.basketData.i % 2 !== 0) ? 'background-color:orangered;' : '')
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("Delink Shipment: ")]), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-size": "130%"
    }
  }, [_vm._v(_vm._s(_vm.basketData.nextbagdestination))])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeCreateDelinkModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Scan Shipment ID:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delinkBagShipmentID),
      expression: "delinkBagShipmentID"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Shipping ID",
      "name": "delinkBagShipmentID",
      "id": "delinkBagShipmentID",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.delinkBagShipmentID)
    },
    on: {
      "keydown": function($event) {
        return _vm.restrictManualTyping($event)
      },
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.delinkBagShipment(_vm.basketData.i)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delinkBagShipmentID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.delinkBagShipmentIDError))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "8%"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', [_c('b', [_vm._v("Shipments for Bag: ")]), _c('b', {
    staticStyle: {
      "cursor": "pointer",
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.basketData.count))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    on: {
      "click": [function($event) {
        return _vm.closeCreateDelinkModal()
      }, function($event) {
        _vm.shipmentModal = true, _vm.confirmDelink = true, _vm.preModal = 'delink'
      }]
    }
  }, [_c('b', {
    staticStyle: {
      "cursor": "pointer",
      "color": "blue",
      "text-decoration-line": "underline"
    }
  }, [_vm._v("Delink All")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.fetchBagShipmentList(_vm.basketData, 'list', _vm.basketData.i), _vm.preModal = 'delink'
      }
    }
  }, [_c('b', {
    staticStyle: {
      "cursor": "pointer",
      "color": "blue",
      "margin-left": "35%",
      "text-decoration-line": "underline"
    }
  }, [_vm._v("View List")])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.confirmDelink),
      expression: "confirmDelink"
    }],
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeCreateDelinkModal(), _vm.fetchBagShipmentList(_vm.basketData, _vm.preModal, _vm.basketData.i)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [(_vm.preModal == 'delink') ? _c('p', [_vm._v("Do you want to delink all Shipping IDs from " + _vm._s(_vm.basketData.nextbagdestination) + " basket?")]) : _c('p', [_vm._v("Alert! Bag closure is not done. Do you still want to go back?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [function($event) {
        return _vm.takeAction(_vm.basketData.i)
      }, _vm.closeCreateDelinkModal]
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeCreateDelinkModal(), _vm.fetchBagShipmentList(_vm.basketData, _vm.preModal, _vm.basketData.i)
      }
    }
  }, [_vm._v("No")])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.showfmlist),
      callback: function($$v) {
        _vm.showfmlist = $$v
      },
      expression: "showfmlist"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.loadingFMList
    },
    on: {
      "update:active": function($event) {
        _vm.loadingFMList = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("Pending Shipment List: ")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showfmlist = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    style: (_vm.fmPendencyList.pendingshipments && _vm.fmPendencyList.pendingshipments.length > 15 ? 'overflow: auto; height: 495px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr.No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.fmPendencyList.pendingshipments), function(data, i) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shippingId))]), _vm._v(" "), (data.shipmentStatus == 'ExecutiveShipmentHubInscan') ? _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-check-circle",
      staticStyle: {
        "color": "green",
        "font-size": "18px"
      }
    })]) : (data.shipmentStatus == 'TOBESHORTAGE' || data.shipmentStatus == 'SHORTAGE') ? _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "color": "red",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(data.shipmentStatus))])]) : (data.shipmentStatus == 'ExecutiveShipmentInscan') ? _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-danger",
      attrs: {
        "disabled": _vm.isfmMarked(data.shippingId) || _vm.fmMarkingIds[data.shippingId]
      },
      on: {
        "click": function($event) {
          return _vm.markFMShortage(data)
        }
      }
    }, [(_vm.fmMarkingIds[data.shippingId]) ? _c('span', [_vm._v("Marking...")]) : (_vm.isfmMarked(data.shippingId)) ? _c('span', {
      staticStyle: {
        "cursor": "not-allowed"
      }
    }, [_vm._v("Already Marked")]) : _c('span', [_vm._v("Request Shortage")])])]) : (data.shipmentStatus == 'ExecutiveShipmentInscan') ? _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "checkbox",
        "id": data.shippingId
      },
      domProps: {
        "checked": _vm.checked[data.shippingId]
      },
      on: {
        "change": _vm.updateCheckDest
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "for": data.shippingId
      }
    }, [_vm._v(" ")])]) : _c('td', {
      staticClass: "text-center"
    }, [_vm._v("--")])])
  }), _vm._v(" "), (!_vm.fmPendencyList.pendingshipments || _vm.fmPendencyList.pendingshipments.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md"
    },
    model: {
      value: (_vm.intiateFMShortage),
      callback: function($$v) {
        _vm.intiateFMShortage = $$v
      },
      expression: "intiateFMShortage"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.loadingFMList
    },
    on: {
      "update:active": function($event) {
        _vm.loadingFMList = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeFMModal()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Do you want to create missing request for pending shipments?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.markFMShortage()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeFMModal()
      }
    }
  }, [_vm._v("No")])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "medium",
      "title": "Confirmation",
      "hide-footer": ""
    },
    model: {
      value: (_vm.showAdherenceModal),
      callback: function($$v) {
        _vm.showAdherenceModal = $$v
      },
      expression: "showAdherenceModal"
    }
  }, [_c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.adherenceMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmAdherence()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelAdherence()
      }
    }
  }, [_vm._v("No")])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-028aaba2","hasScoped":true}!./src/views/components/HubInscan/Manual/Manual.html
// module id = 1021
// module chunks = 2